// This file was auto-generated by Fern from our API Definition.
export var SimpleEvaluatorDataInput;
(function (SimpleEvaluatorDataInput) {
    SimpleEvaluatorDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleEvaluatorDataInput || (SimpleEvaluatorDataInput = {}));
